import { useInfiniteQuery } from '@tanstack/react-query';

import { TPageReviewUiEventDto, useAvApi } from '@app-velocity/av-api-v2';

export const useGetSharedScenarioEvents = (shareToken: string) => {
  const { prototypesShare } = useAvApi();

  const data = useInfiniteQuery({
    queryKey: ['scenario-events', shareToken],
    // enabled: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 60000,
    queryFn: async ({ pageParam }) => {
      if (!shareToken) throw new Error();
      const data =
        await prototypesShare.getV2PrototypesShareReviewsEventsByShareToken(
          { shareToken },
          {
            eventTypes: ['CLICK', 'VIEW_ENTER', 'VIEW_LEAVE', 'FINISH_FAIL', 'FINISH_SUCCESS', 'OVERLAY_ON', 'OVERLAY_OFF'],
            pageable: {
              size: 200,
              page: pageParam,
            },
          }
        );

      return data.data;
    },
    getNextPageParam: (lastPage: TPageReviewUiEventDto) => {
      if ((lastPage.number || 0) + 1 < (lastPage.totalPages || 0)) {
        return (lastPage.number || 0) + 1;
      }

      return undefined;
    },
    initialPageParam: 0,
  });

  return data;
};
